import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExitIcon from "@material-ui/icons/ExitToApp";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import ReceiptIcon from "@material-ui/icons/Receipt";
import React from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { identify } from "../../services/identify/actions";

function ProfileList(props) {
	const [open, setOpen] = React.useState(false);
	let history = useHistory();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleNo = () => {
		setOpen(false);
	};

	const handleYes = () => {
		setOpen(false);
		logout();
	};

	const logout = () => {
		window.localStorage.clear();
		window.location.href = window.location.origin + window.location.pathname;
	};
	return (
		<div>
			<center>
				<p>{props.payoff}</p>
				<h1>{props.firstName + " " + props.lastName}</h1>
				<p>{props.username}</p>
				<List component="nav" aria-labelledby="nested-list-subheader">
					<ListItem button component={Link} to="/orderHistory">
						<ListItemIcon>
							<ReceiptIcon />
						</ListItemIcon>
						<ListItemText primary="Bestelgeschiedenis" />
					</ListItem>
					<ListItem button component={Link} to="/favorites">
						<ListItemIcon>
							<FavoriteBorderIcon />
						</ListItemIcon>
						<ListItemText primary="Favorieten" />
					</ListItem>
					<ListItem button onClick={handleClickOpen}>
						<ListItemIcon>
							<ExitIcon />
						</ListItemIcon>
						<ListItemText primary="Uitloggen" />
					</ListItem>
				</List>
				<Dialog
					open={open}
					onClose={handleNo} // makes it possible to click outside the dialog window to close it
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">
						{"Weet u zeker dat u wilt uitloggen?"}
					</DialogTitle>
					<DialogActions>
						<Button onClick={handleNo} color="primary">
							Nee
						</Button>
						<Button onClick={handleYes} color="primary" autoFocus>
							Ja
						</Button>
					</DialogActions>
				</Dialog>
			</center>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		firstName: state.login.data.firstName,
		lastName: state.login.data.lastName,
		userId: state.login.data.user_id,
		logo: state.login.data.logo,
		payoff: state.login.data.payoff,
		stylesheet: state.login.data.stylesheet,
	};
}

export default connect(mapStateToProps, { identify })(ProfileList);
